import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import { ThemeContextProvider } from "./context/ThemeContext";
import { AuthContextProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import { Container, CircularProgress, Box } from "@mui/material";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import ProtectedRoute from "./ProtectedRoute";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import UserManagement from "./components/Admin/UserManagement";
import RoleManagement from "./components/Admin/RoleManagement";
import EmailManagement from "./components/Admin/EmailManagement";
import SystemOverview from "./components/Admin/SystemOverview";
import ProfilePhotoManagement from "./components/Admin/ProfilePhotoManagement";

const App: React.FC = () => {
  return (
    <ThemeContextProvider>
      <AuthContextProvider>
        <Router>
          <Navbar />
          <Container>
            <Suspense
              fallback={
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  minHeight="100vh"
                >
                  <CircularProgress />
                </Box>
              }
            >
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route
                  path="/account"
                  element={
                    <ProtectedRoute>
                      <Account />
                    </ProtectedRoute>
                  }
                />

                {/* Admin Routes */}
                <Route
                  path="/admin"
                  element={
                    <AdminProtectedRoute>
                      <AdminDashboard />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="/admin/users"
                  element={
                    <AdminProtectedRoute>
                      <UserManagement />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="/admin/roles"
                  element={
                    <AdminProtectedRoute>
                      <RoleManagement />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="/admin/emails"
                  element={
                    <AdminProtectedRoute>
                      <EmailManagement />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="/admin/overview"
                  element={
                    <AdminProtectedRoute>
                      <SystemOverview />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="/admin/profile-photos"
                  element={
                    <AdminProtectedRoute>
                      <ProfilePhotoManagement />
                    </AdminProtectedRoute>
                  }
                />
              </Routes>
            </Suspense>
          </Container>
        </Router>
      </AuthContextProvider>
    </ThemeContextProvider>
  );
};

export default App;
